export async function dispatchWithRetry(dispatch, action, maxAttempts = 3) {

    for (let attempt = 1; attempt <= maxAttempts; attempt++) {
        const res = await dispatch(action);
        if (res?.apiData?.data?.operation_status === "SUCCESS") {
            return { ...action, error: false };
        }
    }

    return { ...action, error: true };
}
